(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pending-order-report', {
            parent: 'entity',
            params:{screen: 'PendingOrderReport'}, 
            url: '/pending-order-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.pendingOrderReport.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pending-order-report/pending-order-report.html',
                    controller: 'PendingOrderReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pendingOrderReport');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('orderActivity');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('order-activity-report', {
            parent: 'pending-order-report',
            url: '/order-activity-report/{orderNumber}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-activity/order-activity.html',
                    controller: 'OrderActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	
                            	 entity: ['OrderActivity', 'GlobalValues', function(OrderActivity, GlobalValues) {
                                     return OrderActivity.get({orderNumber : $stateParams.orderNumber}).$promise;
                                 }],
                                 businessDate: [ 'GlobalValues','DateUtils', function( GlobalValues,DateUtils) {
                                	 var systemSettings = GlobalValues.getSystemSettings();
                                     if(systemSettings!=null && systemSettings!=undefined){
                                     	return DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
                                     	 
                                     }else{
                                    	 return null;
                                     }
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
        
         
         };
    })();
